import React, { useEffect } from "react";
import { Logo } from "assets/svg";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "store/store";
import { fetchHandleResetPassword } from "reducers/authSlice";
import { useNavigate, useSearchParams } from "react-router-dom";

const ResetPassword: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { changePasswordData, errorChangePassword } = useSelector(
    (state: RootState) => state.auth,
  );
  const { register, handleSubmit, formState } = useForm({
    defaultValues: {
      password_new: "",
      password_confirm: null,
    },
  });
  const { errors } = formState;
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const onSubmit = (data: any) => {
    if (data.password_new !== data.password_confirm) {
      alert("パスワードが一致しません");
      return;
    }
    const token = searchParams.get("token");
    if (!token) {
      alert("トークンがありません");
      return;
    }
    dispatch(fetchHandleResetPassword(token, data.password_new));
  };

  useEffect(() => {
    if (changePasswordData?.success) {
      navigate("/reset-password-success");
    }
    if (errorChangePassword) {
      alert(errorChangePassword.message);
    }
  }, [changePasswordData, errorChangePassword]);

  return (
    <main className="bg--blur box">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="w-full rounded-[20px] border-[8px] border-white bg-primary-light shadow-[0_0_15px_0_rgba(0,0,0,0.05)] flex flex-col items-center justify-center py-[52px] px-[22px]
        sm:max-w-[580px] sm:py-[72px] sm:px-[62px]"
      >
        <Logo className="w-[200px] h-[81px] mb-[16px] sm:w-[300px] sm:h-[121px] sm:mb-[24px]" />
        <h2 className="text-[20px] font-bold text-primary mb-[18px] text-center sm:text-[24px] sm:mb-[22px]">
          パスワードの再設定
        </h2>
        <div className="text-[14px] font-normal leading-[160%] text-center mb-[22px] sm:text-[15px] sm:mb-[26px]">
          ご登録のメールアドレスに <br />
          送信されたリンクからアクセスされています。
          <br />
          新しいパスワードを入力し、
          <br className="sm:hidden" />
          再設定を完了してください。
        </div>

        <label className="text-[22px] not-italic font-bold text-primary mb-[5px] sm:text-[18px]">
          新しいパスワード
        </label>
        <input
          {...register("password_new", { required: true, minLength: 8 })}
          type="password"
          className="w-full h-[50px] px-[20px] mb-[20px] rounded-[6px] text-[18px]"
          placeholder="※8文字以上・英数字含む"
          required
        />
        {errors?.password_new?.type === "minLength" && (
          <span className="text-red-500 text-[12px] ml-2">
            8文字以上のパスワードを入力してください。
          </span>
        )}

        <label className="text-[22px] not-italic font-bold text-primary mb-[5px] sm:text-[18px]">
          新しいパスワード（確認）
        </label>
        <input
          {...register("password_confirm", { required: true, minLength: 8 })}
          type="password"
          className="w-full h-[50px] px-[20px] mb-[20px] rounded-[6px] text-[18px]"
          placeholder="※8文字以上・英数字含む"
          required
        />
        {errors?.password_confirm?.type === "minLength" && (
          <span className="text-red-500 text-[12px] ml-2">
            8文字以上のパスワードを入力してください。
          </span>
        )}
        <span className="block text-[12px] mb-[18px] sm:text-[13px] sm:mb-[20px]">
          ※上と同じパスワードをもう一度入力してください。
        </span>

        <button
          type="submit"
          className="w-full bg-primary text-white py-2 rounded-[6px] mb-[15px] sm:max-w-[340px] sm:text-[18px] sm:mb-[20px]"
        >
          パスワードを再設定する
        </button>

        <p className="block text-[12px] mb-[18px] sm:text-[13px] sm:mb-[20px] text-center">
          ※セキュリティ保護のため、他人が推測しにくい <br />{" "}
          パスワードを設定してください。
          <br />
          ※再設定後は、ログインページから新しいパスワードでログインしてください。
        </p>
      </form>
    </main>
  );
};

export default ResetPassword;
